import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Logo } from './Logo';
import { getWhatsAppLink } from '../utils/whatsapp';
const HEADER_WHATSAPP_MESSAGE = 'Hola, equipo de Origen Studio. Quiero conocer más sobre sus sistemas de presencia digital y automatización con IA.';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isDiagnostico = location.pathname === '/diagnostico';
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu on route change
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);
  return <>
      <header className={`fixed top-0 w-full z-[100] transition-all duration-300 ${isScrolled ? 'bg-[#F7F4ED]/90 backdrop-blur-[12px] border-b border-carbon/10' : 'bg-transparent'}`} data-id="element-96" data-mp="3f9nfo5cq4spd">
        <div className="max-w-[1200px] mx-auto px-6 md:px-20 h-[64px] md:h-[72px] flex items-center justify-between" data-id="element-97" data-mp="2rnuhimdtimgr">
          <Link to="/" className="flex items-center" aria-label="Origen Studio — inicio" data-id="element-98" data-mp="2hnli6zoj4kx5">
            <Logo variant="light" data-id="element-99" data-mp="2hpy9w4k3a9ne" />
          </Link>

          {!isDiagnostico ? <>
              {/* Desktop Nav */}
              <nav className="hidden md:flex items-center gap-10" data-id="element-100" data-mp="3abzffd7snd7n">
                <a href="#sistema" className="font-body text-[14px] text-carbon/60 hover:text-carbon/100 transition-opacity duration-150" data-id="element-101" data-mp="35lj2rvbsrvmc">
                  Sistema
                </a>
                <a href="#precios" className="font-body text-[14px] text-carbon/60 hover:text-carbon/100 transition-opacity duration-150" data-id="element-102" data-mp="1xhf5xo3h1yl">
                  Precios
                </a>
                <a href="#demo" className="font-body text-[14px] text-carbon/60 hover:text-carbon/100 transition-opacity duration-150" data-id="element-103" data-mp="1recvfgtjovki">
                  Cómo funciona
                </a>
              </nav>

              {/* Desktop CTA */}
              <div className="hidden md:block" data-id="element-104" data-mp="1ml0d1ofgll07">
                <a href={getWhatsAppLink(HEADER_WHATSAPP_MESSAGE)} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-verde text-arena font-display font-semibold text-[13px] px-5 py-2.5 rounded-[6px] hover:bg-verde-hover hover:-translate-y-[1px] hover:shadow-cta active:translate-y-0 transition-all duration-200" data-id="element-105" data-mp="18mk4dry1dkff">
                  Hablar con ORIGEN
                </a>
              </div>

              {/* Mobile Menu Toggle */}
              <button className="md:hidden text-carbon" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Abrir menú" data-id="element-106" data-mp="2xznn05s4zngn">
                {isMobileMenuOpen ? <X size={24} data-id="element-107" data-mp="w47pye9jvfie" /> : <Menu size={24} data-id="element-108" data-mp="w4pudy6d901e" />}
              </button>
            </> : <div className="flex items-center gap-4 md:gap-8" data-id="element-109" data-mp="re10kc77rqz3">
              <Link to="/" className="hidden md:block font-body text-[14px] text-carbon/60 hover:text-carbon/100 transition-opacity duration-150" data-id="element-110" data-mp="rboblf31ggcj">
                ← Volver al inicio
              </Link>
            </div>}
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      {!isDiagnostico && isMobileMenuOpen && <div className="fixed inset-0 z-[90] bg-arena pt-[72px] px-6 pb-10 flex flex-col md:hidden" data-id="element-111" data-mp="1a50l917oeemk">
          <nav className="flex flex-col gap-8 mt-8" data-id="element-112" data-mp="3guyqdpowb672">
            <a href="#sistema" className="font-body text-xl text-carbon/80" onClick={() => setIsMobileMenuOpen(false)} data-id="element-113" data-mp="3bwdpdo1tkihk">
              Sistema
            </a>
            <a href="#precios" className="font-body text-xl text-carbon/80" onClick={() => setIsMobileMenuOpen(false)} data-id="element-114" data-mp="27wp76eqer8tg">
              Precios
            </a>
            <a href="#demo" className="font-body text-xl text-carbon/80" onClick={() => setIsMobileMenuOpen(false)} data-id="element-115" data-mp="2gx54f6gk5jpv">
              Cómo funciona
            </a>
          </nav>
          <div className="mt-auto" data-id="element-116" data-mp="1p4wd0gzlrhk5">
            <a href={getWhatsAppLink(HEADER_WHATSAPP_MESSAGE)} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center w-full bg-verde text-arena font-display font-semibold text-[15px] px-7 py-4 rounded-[6px] hover:bg-verde-hover transition-colors duration-200" onClick={() => setIsMobileMenuOpen(false)} data-id="element-117" data-mp="1t8catgnernyf">
              Hablar con ORIGEN
            </a>
          </div>
        </div>}
    </>;
}